import React from "react";
import "./Header.css";
import { useAuth } from "../common/AuthContext";
import { Link } from "react-router-dom";

export default function Header() {
  const { user } = useAuth();

  return (
    <header className="header fixed-header">
      <nav className="nav-container">

        {/* LEFT SIDE (LOGO ONLY) */}
        <div className="left-nav">
          <Link to="/" className="logo-container">
            <img
              src="/assets/images/noptionwave-logo-1.png"
              className="logo-image"
              alt="noptionwave logo"
            />
          </Link>
        </div>

        {/* RIGHT SIDE (HOME + LOGIN/SIGNUP) */}
        <ul className="nav-links right-links">
          <li>
            <Link to="/">Home</Link>
          </li>

          {!user && (
            <>
              <li>
                <Link to="/login">Login</Link>
              </li>
              <li>
                <Link to="/signup">Signup</Link>
              </li>
            </>
          )}
        </ul>

      </nav>
    </header>
  );
}
